/** @jsx jsx */
import React from "react"
import { jsx, Divider } from "theme-ui"

const BlogDivider = (): JSX.Element => {
  return <Divider sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.15)" }} />
}

export default BlogDivider
